import { normalizeApiError } from "app/common/api/normalizeApiError";
import * as TeamCRUD from "app/crud/team.crud";

export const actionTypes = {
  TEAM_LOADING: "[TEAM] LOADING",
  MEMBERS_LOADED: "[TEAM] MEMBERS_LOADED",
  INVITES_LOADED: "[TEAM] INVITES_LOADED",
  ROLES_LOADED: "[TEAM] ROLES_LOADED",
  ACTIVITY_LOADED: "[TEAM] ACTIVITY_LOADED",
  SESSIONS_LOADED: "[TEAM] SESSIONS_LOADED",
};

function list(payload) {
  return Array.isArray(payload) ? payload : payload?.data || [];
}

const load = (type, request) => async (dispatch) => {
  dispatch({ type: actionTypes.TEAM_LOADING, payload: true });
  try {
    const { data } = await request();
    dispatch({ type, payload: list(data) });
    return data;
  } catch (error) {
    return Promise.reject(normalizeApiError(error));
  } finally {
    dispatch({ type: actionTypes.TEAM_LOADING, payload: false });
  }
};

export const loadMembers = () => load(actionTypes.MEMBERS_LOADED, TeamCRUD.getMembers);
export const loadInvites = () =>
  load(actionTypes.INVITES_LOADED, () => TeamCRUD.getInvites({ status: "ALL" }));
export const loadRoles = () => load(actionTypes.ROLES_LOADED, TeamCRUD.getWorkspaceRoles);
export const loadActivity = () => load(actionTypes.ACTIVITY_LOADED, TeamCRUD.getActivity);
export const loadMemberSessions = (membershipId) => async (dispatch) => {
  dispatch({ type: actionTypes.TEAM_LOADING, payload: true });
  try {
    const { data } = await TeamCRUD.getMemberSessions(membershipId);
    dispatch({
      type: actionTypes.SESSIONS_LOADED,
      payload: { membershipId, sessions: list(data) },
    });
    return data;
  } catch (error) {
    return Promise.reject(normalizeApiError(error));
  } finally {
    dispatch({ type: actionTypes.TEAM_LOADING, payload: false });
  }
};
